<script>
export default {
  name: 'menu-item',
  functional: true,
  props: {
    icon: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    }
  },
  render(h, context) {
    const { icon, title } = context.props
    const vnodes = []

    // if (icon) {
    //   if (icon === 'home') {
    //     vnodes.push(<svg-icon icon-class={icon}/>)
    //   } else {

    //   }
    // }

    if (title) {
      vnodes.push(<span slot='title'>{(title)}</span>)
    }
    return vnodes
  }
}
</script>



// WEBPACK FOOTER //
// src/layout/components/Sidebar/Item.vue